import { Component, OnInit } from '@angular/core';
import { IdentityService } from '../../../identity/services/identity.service';
import { IUser } from '../../../shared/models/identity.models';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  user!: IUser;
  isServicerHQ = false;

  constructor(private identityService: IdentityService) { }

  ngOnInit(): void {
    this.identityService.getUser().subscribe({
      next: (user) => {
        this.user = user;
        this.isServicerHQ = this.user.role?.split(',').includes('SERVICER_HQ') || false;
      },
      error: (err) => {
        console.error('Error fetching user:', err);
      },
    });
  }
}
